<template>
    <div class="m-2" v-if="results">
        <table class="table">
            <thead>
                <th class="p-1">Вопрос</th>
                <th class="p-1">Ответ</th>
            </thead>
            <tbody>
                <template v-for="(result, index) in results">
                    <tr :key="`result-${index}`">
                        <td class="p-1">
                            {{ result.question.title }}
                        </td>
                        <td class="p-1">
                            {{ getResult(result) }}
                        </td>
                    </tr>
                </template>
            </tbody>
        </table>
    </div>
</template>

<script>
    export default {
        props: {
            entity: {
                type: Object,
                default: () => ({}),
            },
            results: {
                type: Array,
                default: () => ([]),
            },
        },

        data() {
            return {
            };
        },
        created() {
        },

        methods: {
            getResult(result) {
                switch (result.type) {
                    case 'estimation':
                        return result.estimation ?? '—';
                    case 'comment':
                    case 'text':
                        return result.comment ?? '—';
                    case 'single': {
                        const v0 = result.variants && result.variants[0];
                        const variantId = v0 && v0.survey_variant_id;
                        if (variantId == null) return '—';
                        const q = this.entity.questions && this.entity.questions.find(question => question.id === result.survey_question_id);
                        const vari = q && q.variants && q.variants.find(variant => variant.id === variantId);
                        return (vari && vari.title) || '—';
                    }
                    case 'multiple': {
                        const vars = result.variants || [];
                        const ids = vars.map(v => v && v.survey_variant_id).filter(Boolean);
                        if (!ids.length) return '—';
                        const q2 = this.entity.questions && this.entity.questions.find(question => question.id === result.survey_question_id);
                        const variList = (q2 && q2.variants) || [];
                        const titles = variList.filter(v => ids.includes(v.id)).map(v => v.title);
                        return titles.join(', ') || '—';
                    }
                    default:
                        return result.comment ?? '—';
                }
            }
        },
    };
</script>
